export default __webpack_public_path__ + "resources/icons/d330-e39a.webp";